import React from 'react';
import { ScreenShare, ScreenShareOff } from 'lucide-react';
import { useCollab } from '@/contexts/CollabContext';

// Bottom-left profile-area control to start / stop a live screen-share session.
export default function CollabButton() {
  const collab = useCollab();
  if (!collab) return null;
  const { session, isHost, startSession, endSession } = collab;
  const active = !!session;

  const onClick = (e) => {
    e.stopPropagation();
    if (active) endSession(); else startSession();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      title={active ? (isHost ? 'End live session' : 'Leave live session') : 'Share your screen with a teammate'}
      aria-label={active ? 'End live session' : 'Start live session'}
      data-testid="collab-share-btn"
      className={`flex-shrink-0 p-1.5 rounded-lg transition-colors ${active ? 'text-emerald-400 bg-emerald-500/15 hover:bg-emerald-500/25' : 'text-muted-foreground hover:text-primary hover:bg-primary/10'}`}
    >
      {active ? <ScreenShareOff className="w-4 h-4" strokeWidth={1.75} /> : <ScreenShare className="w-4 h-4" strokeWidth={1.5} />}
    </button>
  );
}
